export default "__VITE_PUBLIC_ASSET__89066b57__"